<template>
  <div>
    <v-dialog v-model="hideShow" width="740" persistent scrollable content-class="student-create-dialog" aria-label="添加学员">
      <v-card class="student-create-card">
        <v-card-title class="student-create-header">
          <span class="student-create-symbol"><v-icon color="#d9363e" size="25">mdi-account-plus-outline</v-icon></span>
          <div><h2>添加学员</h2><p>建立学员档案，开启学习旅程</p></div>
          <v-spacer />
          <v-btn icon aria-label="关闭添加学员" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="student-create-body">
          <section class="student-create-section" aria-labelledby="student-create-basic">
            <div class="student-create-section-heading"><h3 id="student-create-basic">学员信息</h3><span><b>*</b> 为必填项</span></div>
            <v-row>
              <v-col cols="12" sm="6"><v-text-field label="学员姓名 *" v-model="add.student.studentName" placeholder="请输入学员姓名" outlined dense hide-details color="#d9363e" /></v-col>
              <v-col cols="12" sm="6"><v-select v-model="add.student.status" :items="statusItems" label="学员状态 *" item-text="name" item-value="id" outlined dense hide-details color="#d9363e" /></v-col>
              <v-col cols="12" sm="6" class="student-create-gender"><v-radio-group label="性别 *" v-model="add.student.gender" row hide-details class="ma-0"><v-radio label="男生" value="1" color="#d9363e" /><v-radio label="女生" value="0" color="#d9363e" /></v-radio-group></v-col>
              <v-col cols="12" sm="6"><div class="student-create-option"><v-select v-model="add.student.studentSource" :items="studentSourceItems" label="生源类型" item-text="sourceName" item-value="id" outlined dense hide-details color="#d9363e" /><v-btn text color="#b92e36" class="student-create-option-add" aria-label="添加生源类型" @click="showCreateSource('1')"><v-icon small>mdi-plus</v-icon>添加</v-btn></div></v-col>
            </v-row>
          </section>
          <section class="student-create-section" aria-labelledby="student-create-contact">
            <div class="student-create-section-heading"><h3 id="student-create-contact">联系人信息</h3></div>
            <v-row>
              <v-col cols="12" sm="6"><v-text-field label="联系人关系" placeholder="如：爸爸 / 妈妈 / 本人" v-model="add.student.contactorCall" outlined dense hide-details color="#d9363e" /></v-col>
              <v-col cols="12" sm="6"><v-text-field label="联系人手机" v-model="add.student.contactorMobile" outlined dense hide-details color="#d9363e" /></v-col>
            </v-row>
          </section>
          <section class="student-create-section" aria-labelledby="student-create-extra">
            <div class="student-create-section-heading"><h3 id="student-create-extra">补充信息</h3><span>选填，可稍后完善</span></div>
            <v-row>
              <v-col cols="12" sm="5"><v-text-field label="学员年龄" suffix="岁" v-model="add.student.age" type="number" outlined dense hide-details color="#d9363e" /></v-col>
              <v-col cols="12" sm="7" class="student-create-avatar"><cutImageUpload :show="hideShow" title="上传学员头像" :waterText="add.student.studentName" @success="uploadSuccess" /></v-col>
              <v-col cols="12" sm="6"><div class="student-create-option"><v-select v-model="add.student.fromSchool" :items="fromSchoolItems" label="就读学校" item-text="sourceName" item-value="id" outlined dense hide-details color="#d9363e" /><v-btn text color="#b92e36" class="student-create-option-add" aria-label="添加就读学校" @click="showCreateSource('2')"><v-icon small>mdi-plus</v-icon>添加</v-btn></div></v-col>
              <v-col cols="12" sm="6"><div class="student-create-option"><v-select v-model="add.student.fromRegion" :items="fromRegionItems" label="居住片区" item-text="sourceName" item-value="id" outlined dense hide-details color="#d9363e" /><v-btn text color="#b92e36" class="student-create-option-add" aria-label="添加居住片区" @click="showCreateSource('3')"><v-icon small>mdi-plus</v-icon>添加</v-btn></div></v-col>
              <v-col cols="12" sm="6"><v-text-field label="身份证号" v-model="add.student.idCardNo" outlined dense hide-details color="#d9363e" /></v-col>
              <v-col cols="12" sm="6"><v-text-field label="家庭住址" v-model="add.student.homeAddress" outlined dense hide-details color="#d9363e" /></v-col>
            </v-row>
          </section>
        </v-card-text>
        <v-card-actions class="student-create-footer">
          <v-spacer />
          <v-btn outlined class="student-create-cancel" @click="cancel">取消</v-btn>
          <v-btn depressed color="#d9363e" dark :loading="add.submiting" @click="submitAddStudent">添加学员</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <createStudentSource :show="createSourceShow" :dataType="createSourceDataType" @cancel="createSourceShow=false" @success="createSourceSuccess" />
  </div>
</template>

<script>
	import utils from "../config/utils"
	import global from "../config/global"
	import uploadPhoto from "./upload_photo.vue"
	import createStudentSource from "./create_student_source.vue"
	import cutImageUpload from "./cut_image_upload.vue"
	export default {
		name:"create-student",
		components:{uploadPhoto,createStudentSource,cutImageUpload},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("create student show=",newVal);
				this.hideShow = newVal;
				if(this.hideShow){

				}
			}
		},
		data(){
			this.submitAddStudent = utils.throttle(this.submitAddStudent,500)
			return {
				imgPrev:global.config.imgPre,
				shopId:"",
				add: {
					submiting:false,
					menuBirthday: false,
					student: {
						studentName: "",
						gender: "",
						avatar: "",
						birthday: "",
						contactorCall: "",
						contactorMobile: "",
						homeAddress: "",
						status: "1",
						studentSource:"",
						age:"",
						idCardNo:""
					},
				},
				statusItems: [{
					id: "1",
					name: "正式学员"
				}, {
					id: "3",
					name: "意向学员"
				}],
				hideShow:this.show,
				createSourceShow:false,
				createSourceDataType:"", // 创建生源的类型
				studentSourceItems:[],// 生源类型
				fromSchoolItems:[],
				fromRegionItems:[]
				
				
			}
		},
		mounted() {
			console.log("create-student mounted");
			this.shopId = utils.getCurrentShopId(); 
			this.getStudentSourceList('1');
			this.getStudentSourceList('2');
			this.getStudentSourceList('3');
		},
		methods:{
			
			cancel(){
				this.$emit("cancel","");
			},
			uploadSuccess(e){
				console.log("上传学员头像成功",e);
				this.add.student.avatar = e.key;
			},
			
			submitAddStudent() {
				
				if (!this.add.student.studentName) {
					this.$noty.error('姓名不能为空');
					return
				}
				if (!this.add.student.gender) {
					this.$noty.error('性别不能为空');
					return
				}
				
				if (!this.add.student.status) {
					this.$noty.error('学员状态不能为空');
					return
				}
				
				if(this.add.student.age){
					if(!utils.isInt(this.add.student.age)){
						this.$noty.error('学员年龄只能输入正整数');
						return
					}
				}
				
				this.add.submiting = true;
				// api
				const that = this;
				let url = `/edu/student/create`;
				let postData = {
					...this.add.student
				};
				postData.shopId = this.shopId;
						
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.add.submiting = false;
							that.$noty.success("添加成功");
							that.$emit("success","");
							
							return;
						} else {
							that.add.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submiting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			getStudentSourceList(dataType){
				
				// api
				const that = this;
				let url = `/edu/shop/student/source/list/${this.shopId}/${dataType}`;	
				
				console.log(url);
				this.axios.get(url).catch(() => {
					
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							
							const result = res.data["data"]||[];
							
							if (dataType=='1'){
								that.studentSourceItems = result;
							}else if (dataType=='2'){
								that.fromSchoolItems = result;
							}else if (dataType=='3'){
								that.fromRegionItems = result;
							}
							
							
							return;
						} 
					} 
							
				});
			},
			showCreateSource(dataType){
				this.createSourceDataType = dataType;
				this.createSourceShow = true;
			},
			createSourceSuccess(){
				this.getStudentSourceList(this.createSourceDataType);
				this.createSourceShow = false;
			}
		}
	}
	
</script>

<style scoped lang="scss">
.student-create-card {
  border-radius: 16px;
  color: #243244;
  .student-create-header { padding: 24px 28px; flex-wrap: nowrap; border-bottom: 1px solid #e9edf2; }
  h2 { font-size: 21px; line-height: 30px; font-weight: 600; letter-spacing: 0; }
  .student-create-header p { margin: 3px 0 0; font-size: 13px; line-height: 20px; color: #6d7989; letter-spacing: 0; }
  .student-create-symbol { display: flex; align-items: center; justify-content: center; width: 48px; height: 48px; flex-shrink: 0; margin-right: 14px; border-radius: 13px; background: #fff0f1; }
  .student-create-body { padding: 0 28px; color: #243244; }
  .student-create-section { padding: 22px 0; }
  .student-create-section + .student-create-section { border-top: 1px solid #edf0f4; }
  .student-create-section-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
  h3 { font-size: 15px; font-weight: 600; line-height: 22px; }
  .student-create-section-heading span { font-size: 12px; color: #6d7989; }
  .student-create-section-heading b { color: #d9363e; }
  .row { margin: -8px; }
  .col-12 { padding: 8px; }
  .student-create-gender { display: flex; align-items: center; min-height: 56px; }
  .student-create-option { display: flex; align-items: center; gap: 8px; }
  .student-create-option > .v-input { min-width: 0; }
  .student-create-option-add { min-width: 62px; padding: 0 8px; height: 38px; background: #fff3f4; border-radius: 7px; }
  .student-create-footer { padding: 18px 28px; border-top: 1px solid #e9edf2; background: #fafbfc; gap: 4px; }
  .student-create-footer .v-btn { min-width: 98px; height: 40px; border-radius: 8px; font-size: 14px; letter-spacing: 0; }
  .student-create-cancel { border-color: #dce2e9; color: #526074; background: #fff; }
  ::v-deep .v-input { font-size: 14px; }
  ::v-deep .v-label { font-size: 14px; color: #657185; }
  ::v-deep .v-text-field--outlined { border-radius: 8px; }
  ::v-deep .v-text-field--outlined:not(.v-input--is-focused) fieldset { border-color: #dce2e9; }
  ::v-deep .v-input--radio-group .v-input--selection-controls__input { margin-right: 6px; }
  .student-create-avatar ::v-deep .v-sheet > div:first-child { width: auto !important; flex: 1; min-width: 0; }
  .student-create-avatar ::v-deep .v-text-field__details { display: none; }
  .student-create-avatar ::v-deep .v-input__slot { margin-bottom: 0; }
  .student-create-avatar ::v-deep .v-avatar { width: 40px !important; min-width: 40px !important; height: 40px !important; margin-top: 4px; }
  @media (max-width: 599px) {
    .student-create-header { padding: 18px; }
    .student-create-body { padding: 0 18px; }
    .student-create-footer { padding: 14px 18px; }
    .student-create-symbol { width: 40px; height: 40px; margin-right: 10px; }
    h2 { font-size: 19px; }
  }
}
</style>
